"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles_1 = require("@material-ui/core/styles");
var framer_motion_1 = require("framer-motion");
var styles_2 = require("../styles");
var progress_bar_styles_1 = require("./progress_bar_styles");
var useStyles = styles_1.makeStyles(progress_bar_styles_1.styles);
var ProgressBar = function (_a) {
    var _b = _a.value, progressValue = _b === void 0 ? 0 : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, className = _a.className, _d = _a.classes, receivedClasses = _d === void 0 ? {} : _d;
    var classes = useStyles({ classes: receivedClasses });
    var theme = styles_1.useTheme();
    var hexColor = react_1.useMemo(function () { return styles_2.getHexFromTheme(theme, color); }, [theme, color]);
    var xValue = -100;
    var xMotion = xValue + progressValue;
    return (react_1.default.createElement("div", { className: classnames_1.default(className, classes.container) },
        react_1.default.createElement(framer_motion_1.motion.div, { className: classes.bar, style: { color: styles_2.getComponentColor(true, hexColor, false) }, initial: { x: xValue + "%" }, animate: { x: xMotion + "%" }, transition: { type: 'tween' } })));
};
exports.ProgressBar = ProgressBar;
